import { useEffect, useState } from 'react';
import { Type } from 'lucide-react';
import { useTools } from '../../ToolProvider.jsx';
import { useEditorTypeRightContext, useEditorTypeRightToggleContext } from '../../SelectedTypeProvider.jsx';

const isTextObject = (object) => object?.type === 'text' || object?.type === 'i-text';

/**
 * Reabre el editor de fuente para el texto seleccionado, a mano.
 *
 * Seleccionar un texto desde el gestor de capas ya no abre el editor solo
 * (era un incordio al solo querer mirar/reordenar capas — ver
 * `isSelectionFromLayerPanel` en Customizer.jsx). Este botón vive junto al
 * selector de color: mismo criterio, solo existe con una única capa de
 * texto seleccionada.
 */
const TextEditButton = () => {
    const { canvas } = useTools() || {};
    const editorTypeRight = useEditorTypeRightContext();
    const setEditorTypeRight = useEditorTypeRightToggleContext();
    const [selection, setSelection] = useState([]);

    useEffect(() => {
        if (!canvas) return undefined;
        // A propósito `canvas.getActiveObjects()`, no la selección anidada de
        // capas: editar la fuente de un texto dentro de un grupo no está
        // soportado (`getActiveTextObject` en editor.js no la resuelve), así
        // que el botón no debe ofrecerlo.
        const refresh = () => setSelection(canvas.getActiveObjects() || []);
        refresh();
        const events = ['selection:created', 'selection:updated', 'selection:cleared'];
        events.forEach(event => canvas.on(event, refresh));
        return () => events.forEach(event => canvas.off(event, refresh));
    }, [canvas]);

    if (selection.length !== 1 || !isTextObject(selection[0])) return null;

    const textObject = selection[0];
    const isOpenForThis = editorTypeRight?.type === 'editor_text';

    const openEditor = () => {
        setEditorTypeRight(prev => ({
            ...prev,
            type: 'editor_text',
            data: {
                ...prev.data,
                is_new: false,
                font: textObject.fontFamily,
                fontStyle: textObject.fontStyle || 'normal',
                fontWeight: textObject.fontWeight || 'normal',
                text: textObject.text,
            },
        }));
    };

    return (
        <div className="customiz3r-text-controls" aria-label="Editar texto de la selección">
            <button
                type="button"
                className={`btn btn-sm btn-circle tooltip tooltip-top ${isOpenForThis ? 'btn-primary' : 'btn-ghost'}`}
                data-tip="Cambiar la fuente del texto"
                aria-label="Cambiar la fuente del texto"
                onClick={openEditor}
            >
                <Type className="h-[1.1rem] w-[1.1rem]" />
            </button>
        </div>
    );
};

export default TextEditButton;
